import { Grid, GridItem } from '@imported/constellation';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeading, ScanDocumentForm } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { DocType } from '../../types/identityContextTypes.js';
import { UK_DRIVING_LICENCE } from '../../utils/constants.js';
import { ROUTE_PATHS } from '../../utils/routePaths.js';
const ScanDocument = () => {
    const { type } = useParams();
    const navigate = useNavigate();
    const [docType, setDocType] = useState();
    const { idvState } = useIdvProvider();
    const { getLabelFromContext } = useLabelContext();
    const options = getLabelFromContext('components.proofOfIdentity.options');
    useEffect(() => {
        const selectedOption = options.find((el) => el.value === type);
        if (selectedOption) {
            if (selectedOption.value === UK_DRIVING_LICENCE) {
                setDocType(DocType.DL_FRONT);
            }
            else {
                setDocType(DocType.PASSPORT);
            }
        }
        else {
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        }
    }, [navigate, options, type]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: getLabelFromContext('containers.proofOfIdentity.pageTitle') }),
        docType && (React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(ScanDocumentForm, { docType: docType })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null))))));
};
export default ScanDocument;
//# sourceMappingURL=index.js.map